@if (isDesktop()) {
  <fu-dropdown #userMenu [closeOnClick]="false">
    @if (opened()) {
      <div class="user-details">
        <div class="user-header d-flex flex-col justify-start">
          <div
            class="user-profile d-flex justify-start align-center"
            [class.active]="activeProfile === 'user'"
            (click)="selectProfile('user')"
          >
            <iw-avatar
              class="avatar"
              [avatar]="userProfile()?.avatar"
              [firstName]="userProfile()?.caption.at(0) ?? ''"
            />
            <div class="d-flex flex-col gap-1">
              <div class="name">{{ userProfile()?.caption ?? "" }}</div>
              <div class="email">{{ userProfile()?.email ?? "" }}</div>
            </div>
            @if (activeProfile === "user" && userProfile()?.isSuperuser) {
              <fu-icon class="checked-icon" size="16" [iconName]="'approval'" />
            }
          </div>
          @if (userProfile()?.isSuperuser) {
            <div
              class="user-profile d-flex justify-start align-center"
              [class.active]="activeProfile === 'treasurer'"
              (click)="selectProfile('treasurer')"
            >
              <iw-avatar
                class="avatar"
                [avatar]="treasurerAvatar"
                firstName="T"
              />
              <div class="d-flex flex-col gap-1">
                <div class="name">
                  {{ "userCardSmall.btn.treasurer" | translate }}
                </div>
                <div class="email">{{ userProfile()?.email ?? "" }}</div>
              </div>
              @if (activeProfile === "treasurer") {
                <fu-icon
                  class="checked-icon"
                  size="16"
                  [iconName]="'approval'"
                />
              }
            </div>
          }
        </div>
        <div class="user-theme d-flex justify-center">
          <div class="theme-btn-wrapper">
            <iw-button uiType="custom" (click)="setTheme('light')">
              <div
                class="theme-button d-flex justify-center align-center light"
                [class.selected]="!themeService.isDarkTheme()"
              >
                <svg>
                  <use
                    [attr.xlink:href]="'assets/icons.svg#light-theme'"
                    [attr.href]="'assets/icons.svg#light-theme'"
                  ></use>
                </svg>
              </div>
            </iw-button>

            <span class="theme-text d-flex justify-center align-end">
              {{ "userCardSmall.btn.lightTheme" | translate }}</span
            >
          </div>

          <div class="theme-btn-wrapper">
            <iw-button uiType="custom" (click)="setTheme('dark')">
              <div
                class="theme-button d-flex justify-center align-center dark"
                [class.selected]="themeService.isDarkTheme()"
              >
                <svg>
                  <use
                    [attr.xlink:href]="'assets/icons.svg#dark-theme'"
                    [attr.href]="'assets/icons.svg#dark-theme'"
                  ></use>
                </svg>
              </div>
            </iw-button>

            <span class="theme-text d-flex justify-center align-end dark">
              {{ "userCardSmall.btn.darkTheme" | translate }}</span
            >
          </div>
        </div>
        <div class="user-actions">
          <iw-button uiType="custom" [disabled]="true">
            <fu-icon iconName="language" size="16"></fu-icon>
            {{ "userCardSmall.btn.en" | translate }}
          </iw-button>
          <iw-button uiType="custom">
            <fu-icon iconName="message-square" size="16"></fu-icon>
            <a [href]="supportLink" target="_blank" rel="noopener noreferrer">
              {{ "userCardSmall.btn.chatSupport" | translate }}
            </a>
          </iw-button>
          @if (activeProfile === "user") {
            <iw-button uiType="custom" (click)="openOrdersHistory()">
              <fu-icon iconName="receipt" size="16"></fu-icon>
              {{ "userCardSmall.btn.ordersHistory" | translate }}
            </iw-button>
          }
          <iw-button uiType="custom" [disabled]="true">
            <fu-icon iconName="settings" size="16"></fu-icon>
            {{ "userCardSmall.btn.settings" | translate }}
          </iw-button>
        </div>
      </div>
    }
  </fu-dropdown>

  <div
    class="user-card-small d-flex justify-center align-center"
    [fuDropdownTriggerFor]="userMenu"
    #trigger="fuDropdownTrigger"
    alignX="end"
    alignY="bottom"
    [inheritWidth]="false"
    (cdkObserveContent)="initDropdown(trigger)"
  >
    <iw-avatar
      class="avatar"
      [avatar]="displayAvatar"
      [firstName]="displayFirstLetter"
    />
    <div class="name">
      {{
        activeProfile === "treasurer"
          ? (displayCaption | translate)
          : displayCaption
      }}
    </div>

    <div>
      <fu-icon iconName="arrow"></fu-icon>
    </div>
  </div>
} @else {
  <div
    class="user-card-small d-flex justify-center align-center"
    (click)="openMobileMenu()"
  >
    <iw-avatar
      class="avatar"
      [avatar]="displayAvatar"
      [firstName]="displayFirstLetter"
    />
  </div>
}
